import { LabelEditModal } from '@/components/diagrams/components/LabelEditModal';

import { useDiagramEditing } from '../../contexts/diagramEditing.context';

/**
 * Shows the shared label modal for the death event before a stage. A line
 * edits its label in place.
 */
export function DiagramLabelEditor() {
  const { diagram, locked, labelTarget, closeLabelEditor, editStage } =
    useDiagramEditing();
  if (locked || !labelTarget) return null;
  const { content } = diagram;

  // The line edits its label in place.
  if (labelTarget.kind === 'edge') return null;

  const stage = content.stages.find((item) => item.id === labelTarget.id);
  if (!stage) return null;
  return (
    <LabelEditModal
      initialLabel={stage.deathEvent ?? ''}
      onClose={closeLabelEditor}
      placeholder="At first death"
      helpText="The event between the previous stage and this stage."
      // Blank text could remove the band, and the band is the only control
      // that edits the label. The backend also rejects a blank one.
      required
      onSave={(label) => editStage(stage.id, { deathEvent: label.trim() })}
    />
  );
}
